import { useCallback } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import ToolsSVG from './ToolsSVG';
import styles from './DevPanel.module.css';

import type { FC, HTMLAttributes } from 'react';

interface DevPanelProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const DevPanel: FC<DevPanelProps> = (props) => {
  const { className, ...restProps } = props;

  const handleOpenModal = useCallback(() => {
    ModalWindows.open('DevPanel');
  }, []);

  return (
    <div className={cn(styles.wrapper, className)} onClick={handleOpenModal} {...restProps}>
      <ToolsSVG className={styles.image} />
    </div>
  );
};

export default DevPanel;
